import * as React from 'react';

type Props = {
  children: React.ReactNode;
};

const ClientOnly = ({ children }: Props) => {
  const [isMounted, setIsMounted] = React.useState(false);

  React.useEffect(() => {
    setIsMounted(true);
  }, []);

  if (!isMounted) {
    return null;
  }

  // To make React know it is returning an element
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
};

export default ClientOnly;
